<script setup>
import GenericCard from '@/components/ui/card/GenericCard.vue';
import Badge from '@/components/ui/badge/Badge.vue';
import { Circle } from 'lucide-vue-next';

const props = defineProps({
    title: {
        type: String,
        required: true
    },
    description: {
        type: String,
        required: true
    },
    recommended: {
        type: Boolean,
        default: false
    },
    selected: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <GenericCard class="cursor-pointer" content-class="pt-6">
        <template #content>
            <div class="flex justify-between items-center gap-2">
                <div class="flex flex-col justify-start items-start gap-2">
                    <div class="flex items-center text-xl font-medium text-primary-font gap-2">
                        <span>
                            {{ title }}
                        </span>
                        <Badge v-if="recommended" variant="outline" class="bg-blue-50 border-primary-blue rounded-2xl font-normal">
                            <span class="text-xs text-primary-blue">
                                Recommended
                            </span>
                        </Badge>
                    </div>
                    <div class="text-sm text-primary-gray">
                        {{ description }}
                    </div>
                </div>
                <div class="text-primary-gray">
                    <div v-if="selected" class="w-4 h-4 rounded-full bg-primary-gray" />
                    <Circle v-else size="16" />
                </div>
            </div>
        </template>
    </GenericCard>
</template>